import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet';

const useStyles = makeStyles((theme) => ({
    appBarSpacer: {
        height: "calc(100vh - "+theme.mixins.toolbar.minHeight+"px)"
    },
	fab: {
		position: "fixed",
		bottom: "60px",
		right: "60px",
		zIndex: "999",
		[theme.breakpoints.down('lg')]: {
			bottom: "50px",
			right: "50px",
		},
		[theme.breakpoints.down('md')]: {
			bottom: "40px",
			right: "40px",
		},
		[theme.breakpoints.down('xs')]: {
			bottom: "30px",
			right: "30px",
		},
	},
}));


function MyMap(props) {
    const classes = useStyles();
    const [map, setMap] = useState(null);

    return (
        <div style={{position: "relative", height: "calc(100vh - 64px)"}}> {/* 64 */}
            <MapContainer 
                center={[44.600105, 0.969806]} 
                zoom={10} 
                scrollWheelZoom={true}
                whenCreated={(ref) => {props.getMapRef(ref); setMap(ref)}}
                // ref={this.mapRef}
                attributionControl={false}
            >
                <TileLayer
                    // detectRetina
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    // attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
                    // url="https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png" 
                />
                {props.markers}
            </MapContainer>
        </div>
    )
}

export default MyMap;




// function medianCenter (markers) {
//     // console.log(markers.props.position)
//     let xcenter = 44.600105
//     let ycenter = 0.969806
//     if(markers.length === 0) return [xcenter, ycenter];
  
//     let allX = []
//     markers.map((marker) => allX.push(marker[0]))

//     let allY = []
//     markers.map((marker) => allY.push(marker[0]))

//     //mediane X
//     allX.sort(function(a,b){
//       return a-b;
//     });
//     var half = Math.floor(allX.length / 2);
//     if (allX.length % 2)
//         xcenter = allX[half]
//     else
//         xcenter = (allX[half - 1] + allX[half]) / 2.0;

//     //mediane Y
//     allY.sort(function(a,b){
//         return a-b;
//     });
//     var half = Math.floor(allY.length / 2);
//     if (allY.length % 2)
//         ycenter = allY[half]
//     else
//         ycenter = (allY[half - 1] + allY[half]) / 2.0;

//     return [xcenter, ycenter]
// }


// const [markerPosition, setMarkerPosition] = useState(null)
    // let coords = [[44.5720687,0.9416287], [44.5750956,0.8817866], [44.508934,0.9392891], [44.6077500,1.1877143], [44.5999093,1.0757921], [45.6221182,0.6417715], [44.5554719,0.9372138], [44.6048753,1.0454429], [44.547357,1.1382667], [44.5827377,1.3752192], [44.6127688,0.8943259], [44.5984784,1.1911798], [44.547437,1.1376477], [44.498431,0.9369053], [44.5677266,0.5024277], [44.5793473,0.9222216], [44.5624985,0.8407270], [44.634619,0.9681672], [44.5551427,0.8753476], [44.9333302,1.1955903], [44.6070746,1.1842048], [44.6177642,1.0556880], [44.5794209,0.3522267], [44.594348,1.1720847], [44.594216,1.1725802], [44.6472417,0.3609720], [44.5563308,1.1150785], [44.6208580,0.8967248], [44.5350013,1.0890979], [44.6451388,0.3615370], [44.5697781,0.3587253], [44.6425766,0.3593127], [44.5218868,1.0358899], [44.4996528,1.1482363], [44.5894023,1.2097601], [44.7204112,1.0897879], [44.8530975,0.9076921], [44.5847172,1.0917499], [44.6333817,0.9501957], [44.6103054,1.1878883], [44.740449,1.3200448], [45.6300856,0.6439224], [44.5823001,1.1858398], [44.684315,1.0716347], [44.5957759,1.0810684], [44.594879,1.1500277], [44.461131,0.8814622], [44.5630627,1.0256871], [44.5951415,1.2417491], [44.5603956,1.0086866], [44.4063154,0.8117157], [44.5282649,0.4134347], [44.7162380,0.8997189], [44.651223,1.1344672], [44.6243535,0.9909468], [44.5720687,0.9416287], [44.5068881,0.3436104], [44.5925320,0.9004337], [44.5348813,1.0890862], [44.5925320,0.9004337], [44.5513719,0.8425305], [44.511578,0.9985472], [44.6141573,1.1399687], [44.4430169,1.1793492], [44.6515754,1.1428430], [44.461131,0.8814622], [44.609933,1.1869683], [44.596555,1.1931667], [44.5930116,0.8981971], [44.5826672,0.9476033], [44.6159313,0.8678076], [44.591629,1.1589577], [44.6127351,0.8945355], [45.6229436,0.6457968], [44.6744241,1.1280583], [44.6742636,0.8467905], [44.6467883,0.3599796], [44.563071,1.0235777], [44.6037551,1.0515691], [44.613441,1.053411], [44.3027692,1.2548594], [44.6177594,0.9357007], [44.4450271,1.1802340], [44.594955,1.1506712], [44.5805476,0.9070413], [44.572154,1.3814452], [44.4246173,1.1853359], [44.5998988,1.0975375], [44.6242817,0.9907440], [44.6136237,0.8479995], [44.6070746,1.1842048], [44.5474797,1.1406895], [44.6699588,1.1270441], [44.547411,1.1392395], [44.551505,1.161969], [44.6070746,1.1842048], [44.5627689,1.0256415], [44.4365667,0.9516213], [44.5916947,0.3668719], [44.6031134,1.0457554], [44.695331,0.9507067], [44.5721267,0.9412435], [44.563071,1.0235777], [44.5858882,1.0057667], [44.5268886,1.1719275]]
    
    // console.log(logo)
    // const iconPerson = new L.Icon({
    //     iconUrl: logo,
    //     // iconRetinaUrl: logo,
    //     // iconAnchor: null,
    //     // popupAnchor: null,
    //     // shadowUrl: null,
    //     // shadowSize: null,
    //     // shadowAnchor: null,
    //     // iconSize: new L.Point(60, 75),
    //     // className: 'leaflet-div-icon'
    // });


    // const markersRef = useRef([]);
    // let markers = []
    // coords.map((arr, i) => {
    //     let position = [arr[0], arr[1]]
    //     markers.push(
    //     <Marker position={position}
    //     key={i}
    //     ref={el => markersRef.current[i] = el}
    //         eventHandlers={{
    //             click: (e) => {
    //                 console.log('marker clicked', e)
    //                 // let newPosition = [(arr[0] + 0.006), arr[1]]
    //                 e.target._map.flyTo(position, e.target._map.getZoom())
    //                 // e.target._map.flyTo(newPosition, e.target._map.getZoom())
    //             },
    //         }}>
    //             <ChantierPopup coords={arr}/>
    //     </Marker>
    //     )
    // });


    // const markerRef = useRef();


    // const [selectValue, setSelectValue] = useState();

    // const [idOpenPopup, setIdOpenPopup] = useState(null);
    // const handleSelectChange = (e) => {
    //     // setSelectValue(e.target.value)
    //     // console.log(e.target.value)
    //     // console.log(markerRef.current.openPopup())

    //     if(idOpenPopup !== null) {
    //         console.log("closing", idOpenPopup)
    //         // markersRef.current[idOpenPopup].closePopup()
    //     }

    //     // markersRef.current.map((marker) => {
    //     //     marker.closePopup()
    //     // })

    //     // setIdOpenPopup(e.target.value)
    //     // map.closePopup()
    //     markersRef.current[e.target.value].togglePopup() //open + flyto en meme temps = bug
    //     console.log(markersRef.current[e.target.value])
    //     // markersRef.current[e.target.value].openPopup()

    //     map.flyTo(markers[e.target.value].props.position, 14)
    //     // setTimeout(markersRef.current[e.target.value].openPopup(), 3000);
    //     // console.log(markers[e.target.value].props.children.leafletElement)
    // }
